import { createContext } from "react";

interface Chooser {
  isSelected(value: unknown): boolean;
  handleChoiceClick(value: unknown, data?: unknown): void;
}

export const ChooserContext = createContext<Chooser | null>(null);
